import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import { AuthContext } from '../../../../../context/AuthContext';
import LoginModal from '../../../../../auth/login'; 
import styles from './HeroText.module.css';

const HeroText = () => {
    const { isAuthenticated } = useContext(AuthContext);
    const [showLoginModal, setShowLoginModal] = useState(false);

    const handleSubmitRequest = (e) => {
        if (!isAuthenticated) {
            e.preventDefault(); // Prevent default Link behavior
            setShowLoginModal(true); // Open login modal instead
        }
        // If authenticated, the Link will naturally navigate to /celebs
    };

    return (
        <>
            <div
                role="presentation"
                className={styles.heroText}
            >
                <div className={styles.textOverlay}></div>

                {/* Main Heading */}
                <div className={styles.mainHeading}>
                    <h2 className={styles.heading}>
                        CONNECT WITH
                        <span className={styles.highlight}> YOUR FAVOURITE STARS</span>
                    </h2>
                </div>

                {/* Sub Heading */}
                <div className={styles.subHeading}>
                    <h2 className={styles.subHeadingText}>
                        Make forever moments
                    </h2>
                </div>

                {/* Buttons */}
                <div
                    role="presentation"
                    className={styles.buttonsContainer}
                >
                    <div className={styles.buttonsOverlay}></div>

                    {/* Submit Request Button */}
                    <div className={styles.submitButtonWrapper}>
                        <Link
                            to={isAuthenticated ? "/celebs" : "#"}
                            aria-label="SUBMIT REQUEST"
                            className={styles.submitButton}
                            onClick={handleSubmitRequest}
                        >
                            <span className={styles.buttonContent}>
                                <span className={styles.buttonText}>SUBMIT REQUEST</span>
                                <span className={styles.buttonIcon}>
                                    <span className={styles.iconWrapper}>
                                        <img
                                            src="https://c.animaapp.com/mhof1dcsmYxOSQ/assets/icon-9.svg"
                                            alt="Icon"
                                            className={styles.icon}
                                        />
                                    </span>
                                </span>
                            </span>
                        </Link>
                    </div>

                    {/* Creator Account Button */}
                    <div className={styles.creatorButtonWrapper}>
                        <a
                            href="/celebrity-login"
                            aria-label="CREATOR ACCOUNT"
                            className={styles.creatorButton}
                        >
                            <span className={styles.buttonContent}>
                                <span className={styles.creatorButtonText}>CREATOR ACCOUNT</span>
                                <span className={styles.buttonIcon}>
                                    <span className={styles.iconWrapper}>
                                        <img
                                            src="https://c.animaapp.com/mhof1dcsmYxOSQ/assets/icon-9.svg"
                                            alt="Icon"
                                            className={styles.icon}
                                        />
                                    </span>
                                </span>
                            </span>
                        </a>
                    </div>
                </div>
            </div>
            <LoginModal show={showLoginModal} onHide={() => setShowLoginModal(false)} />
        </>
    );
};

export default HeroText;